module.exports = __webpack_public_path__ + "img/off-do.f8494831.png";